import React, { Component } from 'react';
import { getAllByFacility, unreadCommunications } from '../../../../services/clinicPortalServices/communicationService';
import { AgGridReact } from 'ag-grid-react';
import ReplyBtnCellRenderer from './replyBtnCellRenderer';
import RepliesCellRenderer from './repliesCellRenderer';
import DetailCellRenderer from './detailCellRenderer';
import FacilityCommunicationBreadcrumb from './facilityCommunicationBreadcrumb';
import moment from 'moment';
import { dateComparator } from '../../../../services/common/util';
import { ThemeContext } from '../../../../theme/ThemeProvider';
import { colorSchemeDark, colorSchemeLight, themeQuartz } from 'ag-grid-community';
import SearchMenu from './searchMenu';

const themeLight = themeQuartz.withPart(colorSchemeLight);
const themeDark = themeQuartz.withPart(colorSchemeDark);

class ClinicFacilityCommunications extends Component {
    constructor(props) {
        super(props);
        this.state = {
            quickFilterText: '',
            columnDefs: [
                {
                    headerName: 'Actions',
                    minWidth: 100,
                    maxWidth: 300,
                    cellStyle: { textAlign: 'center' },
                    field: 'isRead',
                    cellRenderer: 'replyBtnCellRenderer'
                },
                {
                    headerName: 'Subject',
                    field: 'subject',
                    minWidth: 300,
                    maxWidth: 600,
                    resizable: true,
                    cellRenderer: 'agGroupCellRenderer'
                },
                {
                    headerName: 'Created At',
                    field: 'createdAt',
                    minWidth: 200,
                    maxWidth: 300,
                    resizable: true,
                    valueGetter: (params) => {
                        return moment(params.data.createdAt, 'YYYYMMDDHHmmss').format('MM/DD/YYYY hh:mm:ss A');
                    },
                    comparator: dateComparator
                },
                {
                    headerName: 'Replies',
                    minWidth: 120,
                    maxWidth: 120,
                    field: 'replyCount',
                    cellRenderer: 'repliesCellRenderer'
                },
                {
                    headerName: 'Sample Id',
                    resizable: true,
                    field: 'orderId.test_info.sample'
                },
                {
                    headerName: 'Facility',
                    resizable: true,
                    field: 'orderId.facility_source',
                    valueGetter: function addColumns(params) {
                        if (params.data.orderId) {
                            return params.data.orderId.facility_source;
                        } else {
                            return params.data.facilityName;
                        }
                    }
                },
                {
                    headerName: 'From User',
                    minWidth: 200,
                    valueGetter: function addColumns(params) {
                        if (params.data.fromUserId && params.data.fromUserId.first_name) {
                            return params.data.fromUserId.first_name + ' ' + params.data.fromUserId.last_name;
                        } else {
                            return '';
                        }
                    }
                },
                {
                    headerName: 'To User',
                    minWidth: 200,
                    valueGetter: function addColumns(params) {
                        if (params.data.toUserId && params.data.toUserId.first_name) {
                            return params.data.toUserId.first_name + ' ' + params.data.toUserId.last_name;
                        } else {
                            return '';
                        }
                    }
                },
                {
                    headerName: 'User Role',
                    minWidth: 200,
                    field: 'fromRole'
                }
            ],
            components: {
                replyBtnCellRenderer: ReplyBtnCellRenderer,
                repliesCellRenderer: RepliesCellRenderer
            },
            detailCellRenderer: DetailCellRenderer,
            defaultColDef: {
                flex: 1,
                filter: true,
                sortable: true
            },
            communications: [],
            context: { componentParent: this },
            newCommunications: 0,
            showArchived: false,
            filterByDate: false,
            filterDateRange: {
                from_date: moment().subtract(7, 'days').format('YYYY-MM-DD') + 'T00:00',
                to_date: moment().add(1, 'days').format('YYYY-MM-DD') + 'T00:00'
            }
        };
        this.loadGridData();
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
    };

    onFilterTextChange = (e) => {
        this.setState({ quickFilterText: e.target.value });
    };

    clearFilter = () => {
        this.gridApi.setFilterModel(null);
        this.setState({ quickFilterText: '' });
        document.getElementById('reset-form').value = '';
    };

    loadGridData() {
        getAllByFacility({
            showArchived: this.state.showArchived,
            filterByDate: this.state.filterByDate,
            filterDateRange: this.state.filterDateRange
        }).then((res) => {
            if (res.data) {
                this.setState({ communications: res.data });
            }
        });
    }

    componentDidMount() {
        this.getUnreadCommunications();
        setTimeout(() => {
            this.socketConnect();
        }, 500);
    }

    componentDidUpdate(prevProps, prevState) {
        if ((this.state.newCommunications != prevState.newCommunications && this.state.newCommunications > 0) || (this.state.showArchived !== prevState.showArchived) || (this.state.filterByDate != prevState.filterByDate)) {
            this.loadGridData();
        }
        if (this.state.filterByDate && (this.state.filterDateRange != prevState.filterDateRange)) {
            this.loadGridData();
        }
    }

    getUnreadCommunications = () => {
        unreadCommunications().then((res) => {
            if (res.data) {
                this.setState({ newCommunications: res.data.length });
            }
        });
    };

    socketConnect = () => {
        if (window.socket) {
            window.socket.on('updateReadCommunication', (responseData) => {
                this.getUnreadCommunications();
            });
            window.socket.on('updateArchiveCommunication', (responseData) => {
                this.loadGridData();
            });
        }
    };

    handleDateFiltersChange = (dateTime, type) => {
        const filters = { ...this.state.filterDateRange };
        let filterIsValid = true;
        if (type === 'from_date') {
            if (moment(filters.to_date).isAfter(dateTime)) {
                filters.from_date = moment(dateTime).format('YYYY-MM-DD') + 'T00:00';
            } else {
                filterIsValid = false;
            }
        } else {
            if (moment(dateTime).isAfter(filters.from_date)) {
                filters.to_date = moment(dateTime).format('YYYY-MM-DD') + 'T00:00';
            } else {
                filterIsValid = false;
            }
        }
        if (filterIsValid) {
            this.setState({ filterDateRange: filters });
        }
    }

    render() {
        return (
            <div className="clinic-contain">
                <SearchMenu
                    context={this.state.context}
                    onFilterTextChange={this.onFilterTextChange}
                    clearFilter={this.clearFilter}
                    showArchived={this.state.showArchived}
                    onShowArchived={(event) => {
                        this.setState({ showArchived: event.target.checked })
                    }}
                    filterByDate={this.state.filterByDate}
                    from_date={this.state.filterDateRange.from_date}
                    to_date={this.state.filterDateRange.to_date}
                    handleDateFiltersChange={this.handleDateFiltersChange}
                    onFilterByDate={(event) => {
                        this.setState({ filterByDate: event.target.checked })
                    }}
                />
                <div
                    style={{
                        width: '100%',
                        height: 'calc(100vh - 140px)',
                        padding: '15px'
                    }}
                >
                    <ThemeContext.Consumer>
                        {({ themeName }) => (
                            <div
                                id="myGrid"
                                style={{
                                    height: '100%',
                                    width: '100%'
                                }}
                            >
                                <AgGridReact
                                    columnDefs={this.state.columnDefs}
                                    defaultColDef={this.state.defaultColDef}
                                    masterDetail={true}
                                    detailCellRenderer={this.state.detailCellRenderer}
                                    detailRowHeight={500}
                                    onGridReady={this.onGridReady}
                                    rowData={this.state.communications}
                                    pagination={true}
                                    paginationAutoPageSize={true}
                                    components={this.state.components}
                                    context={this.state.context}
                                    theme={themeName === 'Light' ? themeLight : themeDark}
                                    quickFilterText={this.state.quickFilterText}
                                />
                            </div>
                        )}
                    </ThemeContext.Consumer>
                </div>
            </div>
        );
    }
}

export default ClinicFacilityCommunications;
